// Mock data for BulkJobApply Landing Page - SaaS Style

export const heroStats = [
  { number: "93%", label: "Success Rate" },
  { number: "780+", label: "Apps/Month" },
  { number: "Avg. 14 Days", label: "To First Interview" },
  { number: "3 Touches", label: "Per Application" }
];

export const testimonials = [
  {
    id: 1,
    quote: "I was stuck in application purgatory for 4 months. Within 3 weeks of using BulkJobApply, I had 6 interviews lined up. Landed a senior role at a Fortune 500.",
    name: "Marcus Johnson",
    role: "Senior Software Engineer",
    company: "Fortune 500 Tech Company",
    daysToHire: 28,
    stars: 5,
    avatar: "MJ"
  },
  {
    id: 2,
    quote: "As an international student needing sponsorship, I thought I was doomed. Their volume approach got me 12 calls in one month. Now I'm at my dream company.",
    name: "Priya Sharma",
    role: "Product Manager",
    company: "Top Tech Startup",
    daysToHire: 45,
    stars: 5,
    avatar: "PS"
  },
  {
    id: 3,
    quote: "The math doesn't lie. I was sending 50 applications a month with zero results. They sent 780+ and suddenly I'm getting 2-3 calls a week.",
    name: "David Chen",
    role: "Data Scientist",
    company: "FAANG Company",
    daysToHire: 32,
    stars: 5,
    avatar: "DC"
  },
  {
    id: 4,
    quote: "Saved my sanity. I was spending 6 hours a day on applications. Now I focus on interview prep while they handle the grind.",
    name: "Sarah Mitchell",
    role: "Marketing Director",
    company: "Series B Startup",
    daysToHire: 21,
    stars: 5,
    avatar: "SM"
  }
];

export const pricingTiers = [
  {
    id: 2,
    name: "Full Stack",
    price: "$399",
    period: "/month",
    applications: "780 career page apps + tailored resume",
    popular: false,
    duration: "1 month",
    description:
      "One month, fully handled by us. Good pick if you want to try it out. Your team rebuilds your resume, starts up the automation, and begins applying from Day 3.",
    features: [
      "780 career page applications",
      "Tailored resume for your target roles",
      "Triple-Touch outreach on every application",
      "LinkedIn rewrite + referral networking CRM",
      "All done for you by our team",
      "Weekly progress updates via WhatsApp"
    ],
    guarantee: "Dedicated team working on your profile daily",
    cta: "Get Started, $399"
  },
  {
    id: 3,
    name: "Full Stack",
    price: "$625",
    period: "/2 months",
    applications: "Best value, two full months with us",
    popular: true,
    badge: "MOST POPULAR",
    duration: "2 months",
    description:
      "Month 1 lays the groundwork. Applications going out, outreach running, recruiters starting to notice. Month 2 is when interviews start coming in. Most clients who land a job with us do it in weeks 5 to 8. Two months is just how long a real search takes.",
    features: [
      "Everything in the $399 plan",
      "2 full months of done-for-you service",
      "1,560 human-applied applications across both months",
      "Paid upfront so we can go all-in from Day 1",
      "Priority support & weekly WhatsApp updates",
      "Most clients who land do it in this plan."
    ],
    guarantee: "The plan most of our clients actually land a job in",
    cta: "Get Started, $625"
  },
  {
    id: 4,
    name: "Guaranteed",
    price: "$1,499",
    period: " one-time",
    splitPayment: "$750 today, $750 after your first interview.",
    applications: "Until you get 10 interviews",
    popular: false,
    badge: "WE WORK TILL RESULTS",
    duration: "Unlimited",
    description:
      "Pay half today. Pay the rest only once we book your first interview. We keep going until you have 10 interviews. No clock, no small print.",
    features: [
      "Everything in Full Stack, unlimited duration",
      "We don't stop until 10 interviews secured",
      "Weekly strategy call with your team",
      "No time limit. We keep applying till the guarantee is met",
      "Premium priority support",
      "Direct founder access"
    ],
    guarantee: "10 interviews. We don't stop till you're there.",
    cta: "Get Guaranteed, $1,499"
  }
];

export const faqItems = [
  {
    id: 1,
    question: "What is the success rate?",
    answer: "93% of our clients land jobs within 3 months. Here's the breakdown: 47% land jobs directly from our applications, while 46% land through networking (which they finally had time for because we handled the application grind). The industry average is 5-7 months to land a job. We cut that in half."
  },
  {
    id: 2,
    question: "How many interviews will I get?",
    answer: "You're guaranteed 10 interviews in 90 days, that's the minimum, and most clients get far more. Here's why it works: 780+ hand-crafted applications a month, and every hiring manager gets triple-touched (the application, a LinkedIn DM, and a cold email), which pushes your response rate far above the 0.4% industry standard."
  },
  {
    id: 4,
    question: "How are you creating tailored resumes and cover letters?",
    answer: "Human assistants customize each resume for the specific role and company. We use AI to assist with cover letter generation, but every single application is reviewed and approved by a human before submission. No spray-and-pray garbage."
  },
  {
    id: 5,
    question: "Are you a desi consultancy service?",
    answer: "No, nothing like that. We don't take a cut of your salary. We don't put you in contract roles. No hidden fees. You keep every dollar you negotiate. That's it."
  },
  {
    id: 6,
    question: "Do you help for non-tech jobs?",
    answer: "Yes! We're industry-agnostic. We've successfully helped people in marketing, finance, sales, operations, HR, consulting, and more. If the job exists on LinkedIn or job boards, we can apply for it."
  },
  {
    id: 7,
    question: "How is this helpful for me?",
    answer: "We take the boring part off your plate. Instead of spending 4 to 6 hours a day clicking Apply, you get that time back for networking, interview prep, or just to breathe. We handle the volume."
  },
  {
    id: 8,
    question: "What happens after signup?",
    answer: "Day 1: We open a WhatsApp group with you, Priya (HR specialist), and Sarah (your assistant). Day 1 to 2: Priya rewrites your resume from scratch. Day 3: Sarah starts hand-applying. 780+ tailored applications a month, and every hiring manager gets triple-touched with a LinkedIn DM and cold email on top of each application. First interview calls typically land within 14 days. You're live within 72 hours."
  },
  {
    id: 9,
    question: "What if I'm international or need visa sponsorship?",
    answer: "We can absolutely help. Response rates are lower (0.5-1%), but our volume plus Triple-Touch outreach compensates, the LinkedIn DMs and cold emails go straight to hiring managers, bypassing the 'no sponsorship' ATS filters entirely."
  },
  {
    id: 10,
    question: "Is BulkJobApply legit?",
    answer: "Completely. You get a dedicated WhatsApp group with your account manager, HR specialist, and assistant from day one, real humans you can message anytime. Every application is tracked on your live dashboard, so you see exactly where and when we applied. No black box, no ghosting."
  },
  {
    id: 11,
    question: "Will recruiters know someone else applied for me?",
    answer: "No. Every application uses your name, your email, and your tailored resume, it reads exactly like you applied yourself, because a human crafts each one the way you would. The LinkedIn DMs and HR emails are written as your voice too. Recruiters simply see a strong, proactive candidate."
  },
  {
    id: 12,
    question: "What if I don't get interviews?",
    answer: "You're guaranteed 10 interviews in 90 days, that's the minimum, and most clients get far more. If we fall short, we keep working free until you get them. And if those 10 interviews don't turn into an offer, your winning resume and the Triple-Touch automation stay yours so you can keep the momentum going yourself."
  }
];

export const comparisonData = {
  headers: ["What You Get", "Solo", "AI Auto Apply", "Consultancies", "BulkJobApply"],
  rows: [
    {
      feature: "Human-Written Applications",
      values: ["You do it all", "No, AI templates", "Sometimes", "Yes, every single one"],
      highlight: [false, false, false, true]
    },
    {
      feature: "Tailored Resumes & Cover Letters",
      values: ["If you have time", "Generic AI output", "Rarely", "Custom for each role"],
      highlight: [false, false, false, true]
    },
    {
      feature: "Hiring-Manager LinkedIn DMs",
      values: ["Manual effort", "No", "No", "Yes, for every job"],
      highlight: [false, false, false, true]
    },
    {
      feature: "Cold Email to HR",
      values: ["Never", "No", "No", "Yes, for every job"],
      highlight: [false, false, false, true]
    },
    {
      feature: "Fully Managed, You Do Nothing",
      values: ["No", "No", "Partially", "Yes, end to end"],
      highlight: [false, false, false, true]
    },
    {
      feature: "Progress Tracking",
      values: ["Self-tracked", "Dashboard only", "Monthly reports", "Dashboard + WhatsApp weekly"],
      highlight: [false, false, false, true]
    },
    {
      feature: "Proof of Every Application",
      values: ["No", "Logs only", "Rarely", "Dashboard + Monthly PDF reports"],
      highlight: [false, false, false, true]
    },
    {
      feature: "Dedicated Human Support",
      values: ["None", "Chatbot", "Account manager", "WhatsApp group + founder"],
      highlight: [false, false, false, true]
    }
  ],
  bottomLine: [
    { label: "Burnout Central", emoji: "\ud83e\udee0" },
    { label: "Useful But Not Enough", emoji: "\ud83e\udee4" },
    { label: "Pay to Maybe Play", emoji: "\ud83d\udcb8" },
    { label: "Your Career Co-Pilot", emoji: "\ud83d\ude80" }
  ]
};

export const howItWorksSteps = [
  {
    step: 1,
    title: "Tell Us Your Target",
    description: "Fill the 20-second form. Our team messages you within 15 minutes and sets up your dedicated pod in one group: account manager, HR specialist, and your job assistant.",
    icon: "Users",
    duration: "Today"
  },
  {
    step: 2,
    title: "Your Winner Resume Gets Built",
    description: "Your HR specialist rebuilds your resume from scratch, ATS-optimized for your target roles. You confirm salary range, preferred locations, and must-haves.",
    icon: "FileText",
    duration: "Day 1-2"
  },
  {
    step: 3,
    title: "Triple-Touch Goes Live",
    description: "Your assistant hand-applies to 780+ roles a month, and every hiring manager gets all 3 touches: the tailored application, a LinkedIn DM, and a cold email. First interview calls land within 14 days on average.",
    icon: "Rocket",
    duration: "Day 3 onwards"
  }
];

// Live demo data for interactive calculator
export const calculatorDefaults = {
  currentApplications: 50,
  responseRate: 0.4,
  targetInterviews: 10
};

// Dashboard preview data
export const dashboardPreview = {
  totalApplications: 1247,
  thisWeek: 195,
  responses: 18,
  interviews: 7,
  recentActivity: [
    { company: "Google", role: "Senior SWE", status: "Applied", time: "2 min ago" },
    { company: "Meta", role: "Product Manager", status: "Applied", time: "5 min ago" },
    { company: "Stripe", role: "Backend Engineer", status: "Response", time: "1 hr ago" },
    { company: "Airbnb", role: "Data Scientist", status: "Interview", time: "3 hrs ago" },
    { company: "Netflix", role: "ML Engineer", status: "Applied", time: "4 hrs ago" }
  ]
};

// Platform logos for social proof
export const platformLogos = [
  "LinkedIn", "Indeed", "Glassdoor", "ZipRecruiter", "Dice", "AngelList"
];

// Results/Wall of Proof data - Monthly PDFs
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const monthlyResults = [
  {
    id: 1,
    month: "April",
    year: "2025",
    pages: 22,
    pdfUrl: "https://customer-assets.emergentagent.com/job_94552d7a-cb33-4594-bc1a-7a94fd6e5611/artifacts/065pjw9b_April%20report.pdf",
    highlights: "Client results"
  },
  {
    id: 2,
    month: "May",
    year: "2025",
    pages: 50,
    pdfUrl: "https://customer-assets.emergentagent.com/job_94552d7a-cb33-4594-bc1a-7a94fd6e5611/artifacts/ibc2l1dl_May%20report.pdf",
    highlights: "Client results"
  },
  {
    id: 3,
    month: "June",
    year: "2025",
    pages: 50,
    pdfUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_13a9841d-abee-4393-b69d-dc58934d1b0a/artifacts/yco3h19d_june%20RESULTS%20report.pdf",
    highlights: "Client results"
  },
  {
    id: 4,
    month: "July",
    year: "2025",
    pages: 50,
    pdfUrl: "https://customer-assets.emergentagent.com/job_94552d7a-cb33-4594-bc1a-7a94fd6e5611/artifacts/9lzl2kwq_Copy%20of%20July%20report.pdf",
    highlights: "Client results"
  },
  {
    id: 5,
    month: "August",
    year: "2025",
    pages: 50,
    pdfUrl: "https://customer-assets.emergentagent.com/job_94552d7a-cb33-4594-bc1a-7a94fd6e5611/artifacts/u3xneyw1_Aug%20report.pdf",
    highlights: "Client results"
  },
  {
    id: 6,
    month: "September",
    year: "2025",
    pages: 50,
    pdfUrl: "https://customer-assets.emergentagent.com/job_94552d7a-cb33-4594-bc1a-7a94fd6e5611/artifacts/5aicjmxy_September%20report%20%281%29.pdf",
    highlights: "Client results"
  },
  {
    id: 7,
    month: "October",
    year: "2025",
    pages: 50,
    pdfUrl: "https://customer-assets.emergentagent.com/job_94552d7a-cb33-4594-bc1a-7a94fd6e5611/artifacts/6eq0nsng_Copy%20of%20oct%20report%20blkjob.pdf",
    highlights: "Client results"
  },
  {
    id: 8,
    month: "November",
    year: "2025",
    pages: 50,
    pdfUrl: "https://customer-assets.emergentagent.com/job_94552d7a-cb33-4594-bc1a-7a94fd6e5611/artifacts/a2btpdlh_November%20Report%20BJA.pdf",
    highlights: "Client results"
  },
  {
    id: 9,
    month: "December",
    year: "2025",
    pages: 70,
    pdfUrl: `${BACKEND_URL}/api/static/results/dec_report.pdf`,
    highlights: "Client results"
  },
  {
    id: 10,
    month: "January",
    year: "2026",
    pages: 177,
    pdfUrl: `${BACKEND_URL}/api/static/results/jan_report.pdf`,
    highlights: "Client results"
  },
  {
    id: 11,
    month: "February",
    year: "2026",
    pages: 215,
    pdfUrl: `${BACKEND_URL}/api/static/results/feb_report.pdf`,
    highlights: "Client results"
  },
  {
    id: 12,
    month: "March",
    year: "2026",
    pages: 234,
    pdfUrl: `${BACKEND_URL}/api/static/results/mar_report.pdf`,
    highlights: "Client results"
  },
  {
    id: 13,
    month: "April",
    year: "2026",
    pages: 239,
    pdfUrl: `${BACKEND_URL}/api/static/results/apr_report.pdf`,
    highlights: "Client results"
  }
];

// Results metrics
export const resultsMetrics = [
  { value: "10x", label: "More Applications", description: "vs doing it yourself" },
  { value: "93%", label: "Success Rate", description: "land jobs in 3 months" },
  { value: "50%", label: "Faster", description: "than industry average" },
  { value: "6hrs", label: "Saved Daily", description: "focus on what matters" }
];
